import { createUseStyles } from 'react-jss'

export default createUseStyles({
  loadingContainer: {
    padding: '0 10px 5px'
  }
})
